import { createAction } from 'typesafe-actions';
export const useApiQueryActions = {
    /**
     * A new query request has begun
     */
    newRequest: createAction('NEW_REQUEST')(),
    /**
     * Used to sync post-`newRequest` state at the start of `useEffect`
     */
    replaceState: createAction('REPLACE_STATE')(),
    /**
     * A refetchRequest has begun.
     */
    refetchRequest: createAction('REFETCH_REQUEST')(),
    /**
     * A request (or refetchRequest) has completed.
     */
    success: createAction('SUCCESS')(),
    /**
     * A request (or refetchRequest) has failed.
     */
    failure: createAction('FAILURE')(),
    /**
     * The `data` should be set manually.
     */
    setData: createAction('SET_DATA')()
};
//# sourceMappingURL=actions.js.map